import React from 'react';
import { NotificationComponent as NotificationComponentNew } from './Notification';
import { convertOldNotificationProps } from './converter.old';
import type { OldNotificationComponentProps } from './converter.old';

export type NotificationComponentProps = OldNotificationComponentProps;

export const NotificationComponent: React.FC<NotificationComponentProps> = (props) => (
  <NotificationComponentNew {...convertOldNotificationProps(props)} />
);
